export default "__VITE_ASSET__D9daMdJ7__"